import React from 'react';
import MaterialIcon from 'material-icons-react';

import {
  FlexItem,
  CertTitle,
  CertPrice,
  CertContain,
  IconContain,
  CertDescription
} from './CreateStyled';

export const CertificateItem = ({
  item,
  summary,
  onClick,
  selected,
  removePadding,
  renderAction
}) => {
  const handleClick = () => onClick(item.id);

  return (
    <CertContain
      key={item.id}
      summary={summary}
      selected={selected}
      onClick={handleClick}
      removePadding={removePadding}
    >
      <IconContain>
        <MaterialIcon color={'rgb(221, 221, 221)'} size={42} icon="folder_open" />
      </IconContain>
      <FlexItem flex={1}>
        <CertTitle urgent={item.is_urgent}>
          {item.name}
          {(item.gst_unknown && !summary) 
            ? 
            <span style={{ 
              background:   '#fff7ed',
              padding:      '0.15rem 0.375rem', 
              borderRadius: '0.375rem', 
              marginLeft:   '0.25rem', 
              fontSize:     '12px', 
              fontWeight:   400, 
              color:        '#f97316' 
            }}>
              Pre-Auth Required
            </span>
            : null}
        </CertTitle>
        <CertDescription>{item.description}</CertDescription>
      </FlexItem>
      {renderAction && renderAction()}
      {!summary && <CertPrice>${item.price}</CertPrice>}
    </CertContain>
  );
};

CertificateItem.defaultProps = {
  onClick: () => null,
  selected: false
};

export default CertificateItem;
